import { render, staticRenderFns } from "./TeacherProfileManage.vue?vue&type=template&id=744eb65c&scoped=true"
import script from "./TeacherProfileManage.vue?vue&type=script&lang=js"
export * from "./TeacherProfileManage.vue?vue&type=script&lang=js"
import style0 from "./TeacherProfileManage.vue?vue&type=style&index=0&id=744eb65c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744eb65c",
  null
  
)

export default component.exports